'use client';

import { Toast as ToastType } from '@/types/Toast';
import { FC, PropsWithChildren, createContext, useState } from 'react';
import { v4 as uuid } from 'uuid';

type Toast = ToastType & { id: string };

type NotifsContextType = {
  toasts: Toast[];
  addToast?: (toast: ToastType) => void;
  removeToast?: (id: string) => void;
};

export const NotifsContext = createContext<NotifsContextType>({ toasts: [] });

const NotifsContextProvider: FC<PropsWithChildren> = ({ children }) => {
  const [toasts, setToasts] = useState<Toast[]>([]);

  const addToast = (toast: ToastType) => {
    const newToast = { ...toast, id: uuid() };
    setToasts((prevToasts) => [...prevToasts, newToast]);
  };

  const removeToast = (id: string) => {
    setToasts((prevToasts) => prevToasts.filter((toast) => toast.id !== id));
  };

  return (
    <NotifsContext.Provider value={{ toasts, addToast, removeToast }}>
      {children}
    </NotifsContext.Provider>
  );
};

export default NotifsContextProvider;
